define(function (require) {
	"use strict";

	var LE = require("app");
	var template = require("user-management-templates/lobs/lobsGridRowView.tmpl");

	var Checkbox = require("ui/checkbox/Checkbox");

	var LobsGridRowView = {};

	function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

		LobsGridRowView = Marionette.ItemView.extend({
			tagName: "tr",
			className: "lob-row",
			template: template,
			ui: {
				selector: ".selector",
				name: ".name",
				description: ".description",

				//numOfCampaignManagers: ".num-of-campaign-managers",
				numOfUsers: ".num-of-users",
				numOfCampaigns: ".num-of-campaigns",
				numOfSkills: ".num-of-skills",
				numOfContents: ".num-of-contents"
			},
			uiComponents: {
				selectorCheckbox: {
					type: Checkbox,
					options: {
						el: "view.ui.selector",
						checked: false,
						label: "",
						permutation: Checkbox.PERMUTATION.B // no label
					},
					events: {
						"change": "_onSelectorChange"
					}
				}
			},
			events: {
				"click @ui.selector": "_onSelectorWrapperClick",
				"click @ui.name": "_onRowClick",
				"click @ui.description": "_onRowClick",
				//"click @ui.numOfCampaignManagers": "_onRowClick",
				"click @ui.numOfUsers": "_onRowClick",
				"click @ui.numOfCampaigns": "_onRowClick",
				"click @ui.numOfSkills": "_onRowClick",
				"click @ui.numOfContents": "_onRowClick"
			},

            customTemplateHelpers: function() {
                var usersCount = this.model.getCounts(this.model.SUPPORTED_ENTITY_TYPES.USER);
                var campaignsCount = this.model.getCounts(this.model.SUPPORTED_ENTITY_TYPES.CAMPAIGN);
                var skillsCount = this.model.getCounts(this.model.SUPPORTED_ENTITY_TYPES.SKILL);
                var contentsCount = this.model.getCounts(this.model.SUPPORTED_ENTITY_TYPES.CANNED_RESPONSE);
                return {
                    usersCount: usersCount,
                    campaignsCount: campaignsCount,
                    skillsCount: skillsCount,
                    contentsCount: contentsCount
                };
            },

			initialize: function() {
				this.channel = LEUserManagement.media.channel(LEUserManagement.channels.LOB_LIST);
				this._bindEvents();
			},

            onRender: function() {
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    this.ui.numOfUsers.removeClass("hide");
                    this.ui.numOfSkills.removeClass("hide");
                    this.ui.numOfContents.removeClass("hide");
                }
            },

			_bindEvents: function () {
				this.listenTo(this.model, "model:selection:change", this._onModelSelectionChange);
			},

			_onSelectorWrapperClick: function(e) {
				if ($(e.target).hasClass("selector")) {
					this.uiComponents.selectorCheckbox.checkboxClick();
				}
			},

			_onRowClick: function() {
				this.channel.trigger("row:click", this.model);
			},

			_onSelectorChange: function(componentId, eventName, isChecked) {
				this.channel.trigger("row:selector:click", {itemModel:this.model, isChecked:isChecked});
			},

			_onModelSelectionChange: function(isChecked) {
				this.$el.toggleClass("selected", isChecked);
				this.uiComponents.selectorCheckbox.setCheckedState(isChecked);
			}
		});
	}

	LE.module("LEUserManagement", moduleDefinition);

	return LobsGridRowView;
});
